export default __webpack_public_path__ + "static/media/play_store.58c7535a.png";